(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.filter('ShowAllFilter', [ShowAllObjectsFilterFn]);

    // show deactivated entities
    function ShowAllObjectsFilterFn() {
        return function (items, showAll) {
            if (showAll) {
                // no filtering (active and inactive items)
                return items;
            }
            return items.filter(function (item) {
                return item.isDeactivated === false;
            });
        };
    }
})();
